module.exports = __webpack_public_path__ + "static/media/info.fa20229a.png";